import React from "react";
export default ({ data, type, title }) => {
  if (data && title) {
    let andon = data.find((d) => d.metric == title);

    if (andon) {
      if (andon.andon && andon.andon == "RED")
        return <span className="dle-indicator-menu"></span>;
      else if (andon.andon && andon.andon == "GREEN") {
        return <span className="dle-indicator-menu-green"></span>;
      } else return "";
    } else return "";
  }
  if (data && type) {
    let andon = data.find((d) => d.itemId == type);
    if (andon) {
      if (andon.andon && andon.andon == "RED")
        return <span className="dle-indicator"></span>;
      else if (andon.andon && andon.andon == "GREEN")
        return <span className="dle-indicator-green"></span>;
      else return "";
    } else return "";
  }
  return "";
};
